var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqarrowdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_1330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05764 5.80862C2.1157 5.75041 2.18467 5.70423 2.2606 5.67273C2.33653 5.64122 2.41793 5.625 2.50014 5.625C2.58235 5.625 2.66375 5.64122 2.73968 5.67273C2.81561 5.70423 2.88458 5.75041 2.94264 5.80862L10.0001 12.8674L17.0576 5.80862C17.1158 5.75051 17.1847 5.70441 17.2607 5.67296C17.3366 5.64151 17.418 5.62533 17.5001 5.62533C17.5823 5.62533 17.6637 5.64151 17.7396 5.67296C17.8155 5.70441 17.8845 5.75051 17.9426 5.80862C18.0007 5.86673 18.0468 5.93571 18.0783 6.01164C18.1097 6.08756 18.1259 6.16894 18.1259 6.25112C18.1259 6.3333 18.1097 6.41467 18.0783 6.4906C18.0468 6.56652 18.0007 6.63551 17.9426 6.69362L10.4426 14.1936C10.3846 14.2518 10.3156 14.298 10.2397 14.3295C10.1638 14.361 10.0823 14.3772 10.0001 14.3772C9.91793 14.3772 9.83653 14.361 9.7606 14.3295C9.68467 14.298 9.6157 14.2518 9.55764 14.1936L2.05764 6.69362C1.99944 6.63556 1.95326 6.56659 1.92175 6.49066C1.89024 6.41473 1.87402 6.33333 1.87402 6.25112C1.87402 6.16891 1.89024 6.08751 1.92175 6.01157C1.95326 5.93564 1.99944 5.86667 2.05764 5.80862Z",
    fill: "#162766"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_1330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqarrowdown);
export default __webpack_public_path__ + "static/media/faqarrowdown.ba9d3e25a0a69ae821533816d01d564a.svg";
export { ForwardRef as ReactComponent };